import React, { Component } from "react";
import { DatePicker, DayOfWeek } from "office-ui-fabric-react/lib/DatePicker";

export default class DateSelect extends Component {
  _onFormatDate = date => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
  };

  render() {
    const { name, value, label, placeholder, touched, error } = this.props;

    return (
      <div>
        <DatePicker
          value={value ? new Date(value) : ""}
          label={label}
          allowTextInput={true}
          isRequired={false}
          placeholder={placeholder}
          onAfterMenuDismiss={() => this.props.onBlur(name, true)}
          onSelectDate={value => this.props.onChange(name, value)}
          firstDayOfWeek={DayOfWeek.Monday}
          formatDate={this._onFormatDate}
        />
        {!!error && touched && <div className="error-message">{error}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_DateSelect.js